import React, { useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import './QuestionButton.css';

const QuestionButton = ({ options, callback, currentAnswer, navCallback, currentIndex, lastPosition }) => {
  const [ state, setState] = useState(null);
  const answer = currentAnswer ? currentAnswer.answer : null;
  
  const handleClick = (e) => {
    const answer = e.target.dataset.value;
    setState(answer);
    callback(answer);
  }

  const handleClickNav = (e) => {
    const direction = e.target.dataset.direction;
    navCallback(null, direction);
  }

  return (
    <>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-10">
        {options ? options.map( (item) => {
          return (
            <button
              key={uuidv4()}
              className={answer === item.option ? 'btn sm:text-xl text-medium w-full font-medium no-underline text-black inline-block py-3 mb-3 sm:px-3 sm:py-4 bg-white rounded-tl-3xl rounded-br-3xl active' : 'btn sm:text-xl text-medium w-full font-medium no-underline text-black inline-block py-3 mb-3 sm:px-3 sm:py-4 bg-white rounded-tl-3xl rounded-br-3xl'}
              onClick={handleClick} 
              data-value={item.option}
            >
              {item.option}
            </button>
          )
        }):null}
      </div>

      <div className={'text-center mt-20'}>
        {currentIndex !== 0 ?
          <button className={'btn text-medium no-underline text-black inline-block px-1 py-1 bg-white rounded-tl-lg rounded-br-lg py-3 px-6'} onClick={handleClickNav} data-direction={'prev'}>{'Föregående'}</button>
        : null}
        <span className={'mx-4'}>
          <span className={'text-base'}>{ ' ' + (currentIndex+1) } /</span>
          <span className={'text-base'}>{ ' ' + (lastPosition+1) + ' ' }</span>
        </span>
        {currentIndex !== lastPosition ?
          <button className={'btn text-medium no-underline text-black inline-block px-1 py-1 bg-white rounded-tl-lg rounded-br-lg py-3 px-6'} onClick={handleClickNav} data-direction={'next'}>{'Nästa'}</button>
        : null}
      </div>
    </>
  );
};

export default QuestionButton;
